<template>
  <div class="dialog-component">
    <div class="header">
      <div class="left-container">
        <slot name="left"></slot>
      </div>
      <div class="title">
        <slot name="title">{{ title }}</slot>
      </div>
      <img
        @click="close"
        v-if="!hideClose"
        class="close-icon"
        src="../../../../public/images/common/Close@3x.png"
      />
      <div v-else class="close-icon"></div>
    </div>
    <slot></slot>
  </div>
</template>

<style lang="less" scoped>
@import "../../../assets/style/theme";

.dialog-component {
  background: white;
  display: flex;
  max-height: 80vh;
  flex-direction: column;
  min-height: 608px;
  .header {
    color: @color-primary;
    background: white;
    height: 49px;
    align-items: center;
    text-align: center;
    display: flex;
    padding: 0 19px;
    border-bottom: 1px solid #e5e5e5;

    .left-container {
      width: 26px;
      height: 24px;
      font-size: 16px;
      display: flex;
      align-items: center;
    }

    .title {
      flex: 1;
      font-size: 16px;
      color: #000;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: capitalize;
    }

    .close-icon {
      width: 24px;
      height: 24px;
      cursor: pointer;

      &:hover,
      &:active {
        opacity: 0.8;
      }
    }
  }
}
</style>

<script>
export default {
  name: "DialogComponent",
  props: {
    title: {
      // 标题
      type: String,
      default: "",
    },
    hideClose: {
      // 是否隐藏关闭按钮
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
